export default __webpack_public_path__ + "static/media/desktopDemo.97ca4fe6.webp";